jQuery(document).ready(function ($, projectConfig) {
    $("#div-step1").on('click', "a[id^='user_cart_remove_product_" + projectConfig.locale + "']", function (event) {
        event.preventDefault();

        var searchString = 'user_cart_remove_product_' + projectConfig.locale;
        var productId = $(this).attr('id').substring(searchString.length);

        $.ajax({
            type: "POST",
            url: Routing.generate('user_cart_remove_product_' + projectConfig.locale),
            data: { product: productId },
            success: function (data) {
                document.getElementById("cart_item_list").outerHTML = data;
                var nb = document.getElementById("number_items").getAttribute("data-count");
                if(nb == 0){
                    var btnContinue = document.querySelector("p.end-step-block-btn-checkout a");
                    btnContinue.className = "modal-switch-button cssc-button-inactive cssc-button--not-selectable";
                    btnContinue.removeAttribute('href');
                }
            }
        });
    });

    $("#close-btn").on( 'click', function(e) {
        e.preventDefault();
        location.href = $(this).attr('data-href');
    });

    $("#cancel-promo-code").on('click', function (event) {
        event.preventDefault();
        $.ajax({
            type: "POST",
            url: Routing.generate('user_cart_cancel_promo_code_' + projectConfig.locale),
            data: { numberCodeProm: null },
            success: function (data) {
                document.getElementById("cart_item_list").outerHTML = data;
                document.getElementById("code-promo-input").value = null;
                document.getElementById("promo-code-form").style.display = 'inline-block';
                document.getElementById("promo-code-validated").style.display = 'none';
            }
        });
    });
}(jQuery, projectConfig));
